import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import {  CodeListDto } from "@gtpl/shared-models/planning";

export class CodeListResponseModel extends GlobalResponseObject{
    data?: CodeListDto;

    constructor(status: boolean, intlCode: number, internalMessage: string, data?: CodeListDto){
        super(status,intlCode,internalMessage);
        this.status = status;
        this.intlCode = intlCode;
        this.internalMessage = internalMessage;
        this.data = data;
    }
}
